export function appendIdToResponsibles(responsibles) {
  return responsibles.map((responsible, index) => ({
    id: index + 1,
    name: responsible,
  }));
}
